/**
 * Created by vladislav on 19.02.2020
 */

// eslint-disable-next-line
let KnockoutPlayersView = cc.Node.extend({
    avoidNode: "PlayersView",

    ctor: function (competition, round) {
        this._super();

        this.competition = competition;
        this.user = competition.player;
        this.opponent = competition.getPlayerById(round.getOpponentId(this.user.id));

        this.createPlayers();

        this.setAnchorPoint(0.5, 0.5);
        this.onResize();

        this.competition.onChangeResultsListeners.playersView = this.createListener(this.resultsChanged.bind(this));
        this.competition.onGetOpponent = this.createListener(() => this.opponentView);
        this.competition.onGetUserView = this.createListener(() => this.userView);

        if (cleverapps.config.debugMode) {
            [this.userView, this.opponentView].forEach((view) => {
                view.clickRect = cc.rect(view.pos === "left" ? 0 : view.width / 2, 0, view.width / 2, view.height);

                cleverapps.UI.onClick(view, () => {
                    if (cleverapps.forces.isRunningForce()) {
                        return;
                    }

                    if (Game.currentGame) {
                        Game.currentGame.discoverDebug(view.player);
                    }
                });
            });
        }
    },

    createPlayers: function () {
        const scene = cleverapps.Scenes.GetRunningScene();

        this.userView = new KnockoutPlayerView(this.user);
        scene.addChild(this.userView);
        this.userView.setAlignment(cleverapps.styles.KnockoutPlayersView.user);

        this.opponentView = new KnockoutPlayerView(this.opponent);
        scene.addChild(this.opponentView);
        this.opponentView.setAlignment(cleverapps.styles.KnockoutPlayersView.opponent);
    },

    isVertical: function () {
        return cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL || cleverapps.styles.KnockoutPlayersView.vertical;
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        const scale = this.userView.getScale();

        if (this.isVertical()) {
            this.setContentSize2(sceneSize.width, this.userView.height * scale);
        } else {
            this.setContentSize2(this.userView.width * scale, sceneSize.height);
        }

        if (this.isVertical()) {
            this.setAlignment(sceneSize.width / 2, this.userView.y);
        } else {
            this.setAlignment(this.userView.x, sceneSize.height / 2);
        }
    },

    resultsChanged: function (id) {
        const userPoints = this.user.amount;
        const opponentPoints = this.opponent.amount;
        const totalPoints = this.competition.options.algo.maxResult;

        if (id === this.user.id) {
            this.userView.updateProgress();
            if (userPoints === opponentPoints + 1) {
                cleverapps.effects.fire("knockout.player.overtook");
            }
        } else {
            this.opponentView.updateProgress();

            if (opponentPoints === userPoints + 1) {
                cleverapps.effects.fire("knockout.enemy.overtook");
            }
            if (opponentPoints + 1 === totalPoints) {
                cleverapps.effects.fire("knockout.enemy.last_word");
            }
        }

        const isVisible = userPoints < opponentPoints || (userPoints + 1 === totalPoints && opponentPoints + 1 === totalPoints);

        if (isVisible) {
            this.userView.runUserBehindAnimation();
        } else {
            this.userView.stopUserBehindAnimation();
        }
    },

    runForceAvatarAnimation: function (view, callback) {
        const baseScale = view.avatar.getScale();
        view.avatar.runAction(new cc.Spawn(
            new cc.Sequence(
                new cc.RotateTo(0.15, -10),
                new cc.RotateTo(0.15, 10),
                new cc.RotateTo(0.15, -5),
                new cc.RotateTo(0.15, 5),
                new cc.RotateTo(0.1, 0),
                new cc.CallFunc(callback)
            ),
            new cc.Sequence(
                new cc.ScaleTo(0.4, baseScale * 1.3),
                new cc.ScaleTo(0.4, baseScale)
            )
        ));
    },

    runForceAnimation: function () {
        this._forceAnimationRunning = true;

        const animation = function () {
            if (!this._forceAnimationRunning) {
                return;
            }

            this.player = new ActionPlayer([
                function (f) {
                    this.runForceAvatarAnimation(this.userView, f);
                }.bind(this),
                function (f) {
                    this.runForceAvatarAnimation(this.opponentView, f);
                }.bind(this)
            ]);

            this.player.play();
        }.bind(this);

        animation();
    },

    stopForceAnimation: function () {
        this._forceAnimationRunning = false;
        this.player.stop();
        this.userView.stopAllActions();
        this.opponentView.stopAllActions();
    },

    hide: function () {
        [this.userView, this.opponentView].forEach((player) => {
            player.stopAllActions();
            player.runAction(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.ScaleTo(0.3, 0).easing(cc.easeBackIn()),
                new cc.Hide()
            ));
        });
    }
});

cleverapps.styles.KnockoutPlayersView = {
    user: [
        { x: { align: "left", dx: 10 }, y: { align: "top", dy: -125 } },
        { x: { align: "left", dx: 10 }, y: { align: "top", dy: -150 } },
        { x: { align: "left", dx: 10 }, y: { align: "top", dy: -150 } }
    ],
    opponent: [
        { x: { align: "right", dx: -10 }, y: { align: "top", dy: -125 } },
        { x: { align: "left", dx: 10 }, y: { align: "top", dy: -350 } },
        { x: { align: "left", dx: 10 }, y: { align: "top", dy: -350 } }
    ]
};
